import BaseRepository from '@/api/repositories/BaseRepository';

export default class SystemSettingsRepository extends BaseRepository {
	get endpoint() {
		return 'api/system-settings';
	}
	getValue() {
		return this.index({});
	}

	updateValue(id, data) {
		return this.update(id, data, {});
	}
}
